import { isString } from "lodash"

const icd11Regex = /^[A-Z]\d{2}[A-Z](\.\d{1,3})?$/
const icd10Regex = /^[A-Z]\d{2}(\.[A-Z0-9]{1,4})?$/
const icd9Regex = /^([VE]?\d{3})(\.\d{1,2})?$/

export function isValidICDCode(code: string) {
  const trimmedCode = code.trim()
  return (
    trimmedCode &&
    typeof trimmedCode === 'string' &&
    (
      icd11Regex.test(trimmedCode) || // ICD-11
      icd10Regex.test(trimmedCode) || // ICD-10
      icd9Regex.test(trimmedCode) // ICD-9
    )
  )
}

export function detectICDVersion(code) {
  if (!isString(code) || !code) {
    return null
  }

  const trimmedCode = code.trim().toUpperCase()
  if (icd11Regex.test(trimmedCode)) {
    return "ICD-11"
  } else if (icd10Regex.test(trimmedCode)) {
    return "ICD-10"
  } else if (icd9Regex.test(trimmedCode)) {
    return "ICD-9"
  } else {
    return null
  }
}